import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import CommitteeForm from './CommitteeForm';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import Modal from 'react-modal';
import DialogContainer from './Dialogs/DialogContainer';
import axios from 'axios';
import { CommitteesLoader } from './CommitteesLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import {
    fetchCommittees,
    fetchParentCommittees,
    getCommitteeTypes,
    deleteCommittee
} from '../../../../../Redux/Actions/Admin/ManageCommitteeAction';
import {
    fetchPositionGroups
} from '../../../../../Redux/Actions/Admin/ManagePositionActions';
import { connect } from 'react-redux';
import { auth } from '../../../../../services/auth.service';
import { Alert } from 'reactstrap';

const FileDownload = require('js-file-download');


class ManageCommittees extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            committeeInEdit: {},
            isPopupVisible: false,
            committees: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Name", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""

        };
    }

    componentDidMount() {
        this.props.getCommitteeTypes();
        this.props.fetchPositionGroups();
    }

    dataStateChange = (e) => {
        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (committeesFetched) => {
        this.setState({
            ...this.state,
            committees: committeesFetched,
            isLoading: false
        });

        if (committeesFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (committeesFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({ committeeInEdit: this.cloneUser(dataItem), isPopupVisible: true });
    };

    toggleActive = (dataItem) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Name", dir: "asc" }]
            },
        });
        let CommitteeId = dataItem.CommitteeId;
        axios
            .get(`${ROOT_API_URL}/ManageCommittee/ToggleCommitteeActivity?CommitteeId=${CommitteeId}`, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the committee.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }
    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageCommittee/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Committees.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            committeeInEdit: {}
        });
    }

    cloneUser(committee) {
        return Object.assign({}, committee);
    }


    addCommittee = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            isPopupVisible: false,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Name", dir: "asc" }]
            },
        });

        //if (model.ParemtCommittee == undefined || model.ParentCommittee.id == null) { model.ParentCommittee = null; }
        axios
            .post(`${ROOT_API_URL}/ManageCommittee/CreateCommittee`, model, { headers: auth.authHeader() })
            .then(() => {
                this.setState({
                    isSubmitted: false,
                    isLoading: false
                });
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to craete the committee.';

                this.setState({
                    isSubmitted: false,
                    isLoading: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }

    editCommittee = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            isPopupVisible: false,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Name", dir: "asc" }]
            },
        });
       // if (model.ParentCommittee.id == null) { model.ParentCommittee = null; }
        axios
            .post(`${ROOT_API_URL}/ManageCommittee/UpdateCommittee`, model, { headers: auth.authHeader() })
            .then(() => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to update the committee.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                })
            });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"committees-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading committees" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.committees.total}
                                {...this.state.dataState}
                                {...this.state.committees}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.addMember, this.edit, this.toggleActive)} />
                                <Column field="Name" title="Name" filter="text" />
                                <Column field="Acronym" title="Acronym" filter="text" />
                                <Column field="CommitteeType" title="Type" filter="text" />
                                <Column field="PositionGroup" title="Position Group" filter="text" />
                                {/* <Column field="ParentCommitteeName" title="Parent Committee" filter="text" /> */}
                                <Column field="IsActive" title="Is Active" width="150vw" filter="boolean" />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <CommitteesLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <Modal
                                isOpen={Boolean(this.state.committeeInEdit)}
                                onRequestClose={this.cancel}
                                contentLabel="Example Modal"
                                ariaHideApp={false}
                                style={{
                                    content: {
                                        top: '50%',
                                        left: '50%',
                                        right: 'auto',
                                        bottom: 'auto',
                                        marginRight: '-50%',
                                        minWidth: '80vw',
                                        maxWidth: '80vw',
                                        minHeight: '80vh',
                                        maxHeight: '80vh',
                                        overflow: 'auto',
                                        transform: 'translate(-50%, -50%)',
                                        borderRadius: '5px'
                                    }
                                }}
                            >
                                <DialogContainer
                                    dialogType="edit"
                                    dataItem={this.state.committeeInEdit}
                                    save={this.save}
                                    cancel={this.cancel}
                                    addCommittee={this.addCommittee}
                                    committeeTypes={this.props.committee.committeeTypes}
                                   // parentCommittees={this.props.committee.parentCommittees}
                                    updateCommittee={this.editCommittee}
                                    positionGroups={this.props.position.positionGroups}
                                //showToast={this.showToast}
                                />
                            </Modal>
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}
function mapStateToProps(state) {
    return {
        committee: state.committee,
        common: state.common,
        position: state.position
    };
}

export default connect(mapStateToProps, {
    getCommitteeTypes,
    deleteCommittee,
    fetchParentCommittees,
    fetchPositionGroups
})(ManageCommittees);
